
import { Modal, Button, InputGroup, Form, Card, Row, Col, ListGroup, Badge, Tabs, Tab, Alert } from 'react-bootstrap';
import { FaUtensils, FaSearch, FaCheck, FaUser, FaMoneyBill, FaPlus } from 'react-icons/fa';
import { colors } from '../../../../../utils/Colors';

const MenuSelectionModal = ({
  show,
  onHide,
  searchTerm,
  setSearchTerm,
  filteredMenus,
  handleMainMenuSelect,
  addIndividualItem,
  traditionalMehndiMenus,
  baratWalimaMenus,
  ronaqPremiumMenus,
  bbqMenu,
  muttonMenu,
  seaFoodMenu,
  chineseMenu,
  friedDryMenu,
  desserts,
  othersMenu,
  desiMenu,
  formatCurrency
}) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" fullscreen="lg-down" centered>
      <Modal.Header closeButton className="text-white" style={{ backgroundColor: colors.TABLE_HEADERS }}>
        <Modal.Title>
          <FaUtensils className="me-2" />
          Select Menu
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <div className="mb-4">
          <InputGroup>
            <InputGroup.Text><FaSearch /></InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search menus or items..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <Button variant="outline-secondary" onClick={() => setSearchTerm('')}>
                Clear
              </Button>
            )}
          </InputGroup>
        </div>

        <div style={{ width: '95%', margin: '0 auto' }}>
          {searchTerm ? (
            <div className="mb-4">
              <h5 className="fw-bold mb-3">Search Results</h5>
              <Row>
                {filteredMenus.map((menu, index) => (
                  <Col md={6} lg={4} key={index} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm">
                      <Card.Body>
                        <Card.Title className="d-flex justify-content-between align-items-start">
                          <span className="fw-bold">{menu.title}</span>
                          <Badge bg="success" className="ms-2">
                            <FaUser className="me-1" /> {formatCurrency(menu.price)}/person
                          </Badge>
                        </Card.Title>
                        <ListGroup variant="flush" className="small mb-3">
                          {menu.items.slice(0, 4).map((item, idx) => (
                            <ListGroup.Item key={idx} className="py-1 px-0 border-0">
                              <FaCheck className="text-success me-2" size={10} />
                              {item}
                            </ListGroup.Item>
                          ))}
                          {menu.items.length > 4 && (
                            <ListGroup.Item className="py-1 px-0 border-0 text-muted">
                              +{menu.items.length - 4} more items
                            </ListGroup.Item>
                          )}
                        </ListGroup>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleMainMenuSelect(menu)}
                          className="w-100"
                        >
                          <FaCheck className="me-2" />
                          Select Menu (Per Person)
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ) : (
            <>
              {/* Main Menus */}
              <div className="mb-5">
                <h5 className="fw-bold mb-3 d-flex align-items-center" style={{ color: colors.TABLE_HEADERS }}>
                  <div className="me-2 p-2 rounded" style={{ backgroundColor: colors.TABLE_HEADERS, width: '5px' }}></div>
                  Main Menus - Price Per Person
                </h5>
                <Alert variant="info" className="mb-3">
                  <FaUser className="me-2" />
                  <strong>Note:</strong> These menus are priced <strong>PER PERSON</strong>. Price will be multiplied by number of persons.
                </Alert>

                <h6 className="fw-bold mt-4 mb-3">Traditional Mehndi Menus</h6>
                <Row>
                  {traditionalMehndiMenus.map((menu, index) => (
                    <Col md={6} lg={4} key={index} className="mb-3">
                      <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                          <Card.Title className="d-flex justify-content-between align-items-start">
                            <span className="fw-bold">{menu.title}</span>
                            <Badge bg="warning" className="ms-2">
                              <FaUser className="me-1" /> {formatCurrency(menu.price)}/person
                            </Badge>
                          </Card.Title>
                          <ListGroup variant="flush" className="small mb-3">
                            {menu.items.slice(0, 3).map((item, idx) => (
                              <ListGroup.Item key={idx} className="py-1 px-0 border-0">
                                <FaCheck className="text-success me-2" size={10} />
                                {item}
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                          <Button
                            variant="outline-warning"
                            size="sm"
                            onClick={() => handleMainMenuSelect(menu)}
                            className="w-100 mt-2"
                          >
                            <FaCheck className="me-2" />
                            Select Menu
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>

                <h6 className="fw-bold mt-4 mb-3">Barat/Walima Menus</h6>
                <Row>
                  {baratWalimaMenus.map((menu, index) => (
                    <Col md={6} lg={4} key={index} className="mb-3">
                      <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                          <Card.Title className="d-flex justify-content-between align-items-start">
                            <span className="fw-bold">{menu.title}</span>
                            <Badge bg="info" className="ms-2">
                              <FaUser className="me-1" /> {formatCurrency(menu.price)}/person
                            </Badge>
                          </Card.Title>
                          <ListGroup variant="flush" className="small mb-3">
                            {menu.items.slice(0, 3).map((item, idx) => (
                              <ListGroup.Item key={idx} className="py-1 px-0 border-0">
                                <FaCheck className="text-success me-2" size={10} />
                                {item}
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => handleMainMenuSelect(menu)}
                            className="w-100 mt-2"
                          >
                            <FaCheck className="me-2" />
                            Select Menu
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>

                <h6 className="fw-bold mt-4 mb-3">Ronaq Premium Menus</h6>
                <Row>
                  {ronaqPremiumMenus.map((menu, index) => (
                    <Col md={6} lg={4} key={index} className="mb-3">
                      <Card className="h-100 border-0 shadow-sm">
                        <Card.Body>
                          <Card.Title className="d-flex justify-content-between align-items-start">
                            <span className="fw-bold">{menu.title}</span>
                            <Badge bg="success" className="ms-2">
                              <FaUser className="me-1" /> {formatCurrency(menu.price)}/person
                            </Badge>
                          </Card.Title>
                          <ListGroup variant="flush" className="small mb-3">
                            {menu.items.slice(0, 3).map((item, idx) => (
                              <ListGroup.Item key={idx} className="py-1 px-0 border-0">
                                <FaCheck className="text-success me-2" size={10} />
                                {item}
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => handleMainMenuSelect(menu)}
                            className="w-100 mt-2"
                          >
                            <FaCheck className="me-2" />
                            Select Menu
                          </Button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>

              {/* Individual Items */}
              <div className="mb-4">
                <h5 className="fw-bold mb-3 d-flex align-items-center" style={{ color: colors.TABLE_HEADERS }}>
                  <div className="me-2 p-2 rounded" style={{ backgroundColor: colors.TABLE_HEADERS, width: '5px' }}></div>
                  Individual Items (For Custom Menu)
                </h5>
                <Alert variant="warning" className="mb-3">
                  <FaMoneyBill className="me-2" />
                  <strong>Note:</strong> These items are for <strong>CUSTOM MENU</strong>. Add items and set custom per head amount above.
                </Alert>

                <Tabs defaultActiveKey="bbq" className="mb-3">
                  <Tab eventKey="bbq" title="BBQ Items" className="px-3">
                    <Row>
                      {bbqMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    BBQ Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-warning"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'BBQ')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="mutton" title="Mutton Items" className="px-3">
                    <Row>
                      {muttonMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    Mutton Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'Mutton')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="seafood" title="Sea Food" className="px-3">
                    <Row>
                      {seaFoodMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    Sea Food Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'Sea Food')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="chinese" title="Chinese" className="px-3">
                    <Row>
                      {chineseMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    Chinese Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'Chinese')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="fried" title="Fried & Dry" className="px-3">
                    <Row>
                      {friedDryMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    Fried & Dry Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-dark"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'Fried & Dry')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="desserts" title="Desserts" className="px-3">
                    <Row>
                      {desserts.map((dessert, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{dessert.name}</h6>
                                  <small className="text-muted">Sweet Delight</small>
                                </div>
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  onClick={() => addIndividualItem({ name: dessert.name }, 'Desserts')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="others" title="Others" className="px-3">
                    <Row>
                      {othersMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    Other Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'Others')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>

                  <Tab eventKey="desi" title="Desi Items" className="px-3">
                    <Row>
                      {desiMenu.map((item, index) => (
                        <Col md={6} lg={4} key={index}>
                          <Card className="mb-3 border-0 shadow-sm">
                            <Card.Body className="py-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">{item.name}</h6>
                                  <small className="text-muted">
                                    Desi Item
                                  </small>
                                </div>
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={() => addIndividualItem(item, 'Desi')}
                                  className="rounded-circle"
                                  style={{ width: '36px', height: '36px' }}
                                >
                                  <FaPlus />
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Tab>
                </Tabs>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <div>
          <Badge bg="warning" className="me-2">Per Person</Badge>
          <Badge bg="info" className="me-2">Custom Menu Items</Badge>
        </div>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MenuSelectionModal;